import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Button';
import InspectTab from './components/InspectTab';

import './style.scss';

const InspectTabs = ({
  item,
  tabs,
  icon,
  selectedTabIndex,
  changeTab,
  closeTabs,
  rightOptions,
}) => (
  <div styleName="concept-tab">
    <div styleName="left-links">
      <div styleName="name-block">
        <span className={icon} styleName="icon" />
        <span data-test="tabs-name" styleName="name">
          {item.name}
        </span>
      </div>
      {tabs.map(tab => (
        <InspectTab
          key={tab.tabIndex}
          actions={item.actions}
          changeTab={changeTab}
          matchingPattern={item.matching_pattern_elements}
          selectedTab={selectedTabIndex}
          tab={tab}
        />
      ))}
    </div>
    <div styleName="right-links">
      {rightOptions}
      <div styleName="close">
        <Button isLink data-test="close-inspect-window" onClick={closeTabs}>
          <i className="icon-close" />
        </Button>
      </div>
    </div>
  </div>
);

InspectTabs.propTypes = {
  changeTab: PropTypes.func.isRequired,
  closeTabs: PropTypes.func.isRequired,
  icon: PropTypes.string.isRequired,
  item: PropTypes.shape({
    actions: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.string,
    matchingPattern: PropTypes.arrayOf(PropTypes.object),
    name: PropTypes.string,
  }).isRequired,
  selectedTabIndex: PropTypes.number.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
  rightOptions: PropTypes.node,
};

InspectTabs.defaultProps = {
  rightOptions: null,
};

export default InspectTabs;
